export function getTimestampInSeconds() {
  return Math.floor(Date.now() / 1000);
}
